var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplyjob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 488,
    height: 488,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M0 0L0 488L488 488L488 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M294 52L294 53L341 53C328.823 47.8905 307.265 52 294 52M295 195L295 194C288.16 194 273.943 191.306 268.329 195.603C263.825 199.051 256.979 221.932 250.101 218.248C243.326 214.62 237.982 199.344 233.421 193C228.855 186.651 220.511 180.25 217.742 173C214.787 165.262 217 153.227 217 145C217 121.622 209.375 81.0274 228.043 63.1042C242.48 49.2433 274.369 54 293 54C284.826 50.5701 271.667 53.0055 263 53.8302C250.318 55.0371 237.678 51.9436 227.301 61.5178C207.915 79.4034 216 122.365 216 146C216 154.42 213.953 165.964 216.564 174C219.024 181.57 227.582 187.661 232.244 194C237.032 200.51 242.058 216.255 249.133 219.953C257.989 224.582 264.462 200.538 270.104 196.603C275.824 192.615 288.255 195 295 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M293 53L293 54L342 54C329.348 48.691 306.788 53 293 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M342 53L342 54L371 56L342 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M266 54L266 55L283 55L266 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M283 54.4244C267.968 56.3981 249.002 52.0879 235 58.6451C209.396 70.635 218 117.28 218 140C218 149.86 215.209 164.752 218.742 174C222.252 183.187 233.16 191.56 238.655 200C241.247 203.98 246.413 218.364 251.858 218.364C255.227 218.364 256.985 213.416 258.255 211C261.446 204.934 265.368 194.341 273.001 193.148C299.918 188.941 330.723 193 358 193C371.381 193 388.187 193.045 397.736 181.96C403.855 174.857 404.269 165.775 405.424 157C408.145 136.343 408.322 113.665 405.576 93C404.566 85.4048 405.518 72.1912 398.867 67.1049C389.967 60.2993 376.756 58.2445 366 56.5756C340.022 52.545 309.166 50.9888 283 54.4244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M349 54L349 55L357 55L349 54M243 55L243 56L260 56L243 55M359 55L359 56L365 56L359 55M238 56L238 57L242 57L238 56M365 56L365 57C377.325 57.2558 401.662 62.2579 403 77C408.804 62.0892 374.517 56.0788 365 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M372 56L372 57L376 57L372 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M235 57L235 58L238 58L235 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M376 57L376 58L380 58L376 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M234 58L235 59L234 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M380 58L380 59L384 59L380 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M232.667 59.3333L233.333 59.6667L232.667 59.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M384 59L384 60L387 60L384 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M230.667 60.3333L231.333 60.6667L230.667 60.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M387 60L387 61L392 62L392 61L387 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M229 61L230 62L229 61M228 62L229 63L228 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M392 62L392 63L396 64L396 63L392 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M227 63L228 64L227 63M226 64L227 65L226 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M396.667 64.3333L397.333 64.6667L396.667 64.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M225 65L224 68L225 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M398.667 65.3333L399.333 65.6667L398.667 65.3333M400 66L403 69L400 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M223.333 68.6667L223.667 69.3333L223.333 68.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M403 69L403 72L404 72L403 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M222.333 70.6667L222.667 71.3333L222.333 70.6667M233 87L234 87C240.025 71.1094 253.419 71 268 71C301.17 71 337.116 67.0261 370 71.1852C379.148 72.3422 385.16 79.8078 388 88C391.25 72.288 369.087 70 359 70L265 70C251.517 70 236.489 70.9298 233 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M368 71L368 72C376.751 73.3117 383.335 78.6802 386.532 87C389.124 93.7467 388 101.898 388 109C388 127.292 394.4 158.636 378.985 171.775C369.822 179.586 355.15 177 344 177C314.647 177 284.245 179.306 255 176.907C225.245 174.465 234 130.237 234 110C234 101.371 232.232 90.6722 236.995 83C247.802 65.5889 278.505 72 296 72C290.538 69.7079 282.887 71 277 71C261.732 71 242.584 67.3661 234.674 84C229.332 95.2331 233 114.704 233 127C233 143.532 227.831 168.44 247 176.235C256.903 180.263 270.475 178 281 178L351 178C362.712 178 376.342 179.698 384.211 168.985C390.136 160.916 389 151.452 389 142C389 121.706 398.404 72.3927 368 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M296 71.4244C280.289 73.4872 255.205 66.144 242.015 76.4182C233.554 83.0091 234 92.3286 234 102L234 151C234.001 159.193 234.857 167.098 242.015 172.362C251.857 179.599 266.502 177 278 177C307.125 177 340.302 181.469 369 176.674C376.724 175.384 383.406 170.328 386.387 163C389.006 156.558 388 148.801 388 142C388 124.878 394.161 92.9531 382.61 79.0432C376.251 71.3863 366.153 71 357 71C337.084 71 315.744 68.832 296 71.4244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M221.333 72.6667L221.667 73.3333L221.333 72.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M404 72L404 78L405 78L404 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M220 74L220 77L221 77L220 74M219 77L219 81L220 81L219 77M404 78L405 93L406 93L404 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M405 79L405 85L406 85L405 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M218 82L218 86L219 86L218 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M406 85L408 125L406 164L407 164L408.015 109L406 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M217 87L217 174L218 174L218 114L217 87M232 88L232 160L233 160L233 111L232 88M389 91L389 96L390 96L389 91M406 96L406 108L407 108L406 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M313 104L313 125L314 125L314 105L320 105L313 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M314 105L314 139C319.82 138.695 329.011 141.573 333.656 137.486C344.464 127.977 333.469 110.59 320 118L319 105L314 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M319 105L320 118L324 115L320 117L319 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M269.667 106.333L270.333 106.667L269.667 106.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M271 106L271 107L275 107L275 132C277.474 126.105 278.656 107.278 271 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M275 106L276 107L275 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M269.333 107.667L269.667 108.333L269.333 107.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M270 107C270 113 273.259 133.454 264.956 134.864C262.034 135.361 258.664 132.966 256 132C254.71 141.027 268.807 142.196 273.142 135.867C277.737 129.158 275 114.837 275 107L270 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M276 107L276 132L277 132L276 107M269 109L270 110L269 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M269 110L269 132L270 132L269 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M290.667 114.333L291.333 114.667L290.667 114.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M292 114L292 115L298 115L292 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M298.667 114.333L299.333 114.667L298.667 114.333M323 114L323 115L326 115L323 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M326 114L326 115L330 115L326 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M330 114L330 115L337 123L338 123C337.019 118.152 334.666 115.601 330 114M347.667 114.333L348.333 114.667L347.667 114.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M349 114L349 115L354 115L349 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M354 114L354 115L361 117L357 121C364.258 121.163 358.851 114.542 354 114M288 115L283 121L284 121L289 116L288 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M289.667 115.333L290.333 115.667L289.667 115.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M291.005 115.573C276.975 119.642 283.116 143.206 297.996 139.438C312.988 135.643 306.712 111.017 291.005 115.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M299 115L299 116L302 117L299 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M301 115L302 116L301 115M320 117L323 115L320 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M331 115L332 116L331 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M345 115C341.765 119.498 341.607 123.027 344 128L345 128L345 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M343 120L344 120L348 116L343 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M344 133L343 137C348.384 139.822 367.299 140.191 360.102 129.225C358.417 126.658 347.976 124.695 349.346 121.21C350.576 118.08 357.362 119.572 360 119L360 117C355.019 114.889 340.131 113.84 343.786 123.815C345.691 129.013 352.251 127.571 355.029 131.339C359.466 137.357 345.488 133.606 344 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M357 115L358 116L357 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M302 116L302 117C306.836 121.16 306.996 125.959 307 132L308 132C307.999 125.604 308.372 119.313 302 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M333 116L334 117L333 116M358.667 116.333L359.333 116.667L358.667 116.333M407 116L407 134L408 134L407 116M286 117L287 118L286 117M303 117L304 118L303 117M334 117L335 118L334 117M360.333 117.667L360.667 118.333L360.333 117.667M285 118L286 119L285 118M304 118L305 119L304 118M335 118L336 119L335 118M289 123C293.616 120.477 296.392 119.687 300 124C300.155 117.009 291.936 119.476 289 123M321 120L321 121L331 122C327.906 118.844 325.167 119.023 321 120M349 119C348.197 122.434 348.698 123.672 352 125L352 124L349 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M350 119L350 120L354 120L350 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M354 119L354 120L359 121L359 120L354 119M359 119L360 120L359 119M284 120L283 123L284 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M292 120L289 131L290 131L292 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M293.147 121.086C287.621 123.811 289.63 136.184 296.853 133.377C302.76 131.082 299.745 117.833 293.147 121.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M297 120L298 121L297 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M305.333 120.667L305.667 121.333L305.333 120.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M323 120L320 124L323 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M324.054 121.137C317.47 123.991 320.54 136.344 327.722 133.377C333.372 131.043 330.651 118.277 324.054 121.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M327.667 120.333L328.333 120.667L327.667 120.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M336.333 120.667L336.667 121.333L336.333 120.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M349 120L350 121L349 120M355 120L356 121L355 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M389 120L389 128L390 128L389 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M298 121L299 122L298 121M329 121L330 122L329 121M299 122L300 123L299 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M306 122L306 127L307 127L306 122M320 122L321 123L320 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M330 122L330 125L331 125L330 122M349 122L350 123L349 122M282 123L282 132L283 132L282 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M331 123L331 127L332 127L331 123M337 123L337 131L338 131L337 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M350 123L351 124L350 123M300 124L300 131L301 131L300 124M338 124L338 131L339 131L338 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M343 124L344 125L343 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M352 124L352 125L355 125L352 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M288 125L288 130L289 130L288 125M301 125L301 130L302 130L301 125M313 125L313 132L314 132L313 125M319 125L319 130L320 130L319 125M354 125L354 126L361 129L354 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M357.667 125.333L358.333 125.667L357.667 125.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M344 126L344 127L349 129L349 128L344 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M359 126L360 127L359 126M331 127L332 128L331 127M360 127L361 128L360 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M331 128L331 132L332 132L331 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M346 128L347 129L346 128M361 128C362.051 134.508 359.661 138.652 353 140L353 141C359.717 140.251 365.454 134.558 361 128M268 129L267 134L268 134L268 129M348 129L348 130L355 132L355 134L351 135L351 136L356 131L348 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M351.667 129.333L352.333 129.667L351.667 129.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M259 140L259 139C255.41 136.096 254.589 133.402 259 131C251.788 129.502 253.905 137.911 259 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M283 130L283 133L284 133L283 130M306 130L306 133L307 133L306 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M320 130C321.547 134.044 323.819 134.769 328 135L328 134L320 130M330 130L329 134L330 134L330 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M354.667 130.333L355.333 130.667L354.667 130.333M361.333 130.667L361.667 131.333L361.333 130.667M256 131L256 132L260 134L256 131M289 131C290.865 134.7 292.911 135.692 297 136L297 135L289 131M300 131L298 135L300 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M337 131L337 134L338 134L337 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M255 132L256 133L255 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M259 132L260 133L259 132M275 132L275 135L276 135L275 132M290 132L291 133L290 132M299 132L300 133L299 132M313 132C313.021 137.937 313.534 140.788 320 141L320 140L314 140L313 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M320 132L321 133L320 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M344 132L344 133L350 135L350 134L344 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M356 132L357 133L356 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M260 133L260 134L266 135L266 134L260 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M268 133L269 134L268 133M274 133L271 139L274 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M283 133C284.862 138.347 288.495 140.432 294 141L294 140L283 133M291 133L292 134L291 133M298 133L299 134L298 133M306 133C303.477 137.137 300.785 139.131 296 140L296 141C300.542 140.532 306.746 138.532 306 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M330 133L331 134L330 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M343 133C341.56 136.743 342.463 138.198 346 140L346 139L343 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M345.667 133.333L346.333 133.667L345.667 133.333M361.333 133.667L361.667 134.333L361.333 133.667M254.333 134.667L254.667 135.333L254.333 134.667M261 134L262 135L261 134M266.667 134.333L267.333 134.667L266.667 134.333M284 134L285 135L284 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M292 134L292 135L298 135L292 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M305 134L306 135L305 134M322 134L323 135L322 134M328.667 134.333L329.333 134.667L328.667 134.333M336 134L333 139L336 134M343 134L344 135L343 134M347 134L348 135L347 134M355 134L356 135L355 134M263 135L263 136L266 136L263 135M304 135L305 136L304 135M324 135L324 136L328 136L324 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M336 135L337 136L336 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M342.333 135.667L342.667 136.333L342.333 135.667M349.667 135.333L350.333 135.667L349.667 135.333M354 135L355 136L354 135M255 136L256 137L255 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M274 136L275 137L274 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M285 136L286 137L285 136M360 136L361 137L360 136M389 136L389 145L390 145L389 136M256 137L257 138L256 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M273 137L274 138L273 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M286 137L287 138L286 137M302.667 137.333L303.333 137.667L302.667 137.333M314 139L314 140L320 138L325 140L314 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M335 137L336 138L335 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M343 137L344 138L343 137M359 137L360 138L359 137M257 138L258 139L257 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M272 138L273 139L272 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M288 138L289 139L288 138M301 138L302 139L301 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M320.667 138.333L321.333 138.667L320.667 138.333M334 138L335 139L334 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M344.667 138.333L345.333 138.667L344.667 138.333M358 138L359 139L358 138M259 139L259 140L262 140L259 139M268.667 139.333L269.333 139.667L268.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M270.667 139.333L271.333 139.667L270.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M290.667 139.333L291.333 139.667L290.667 139.333M298.667 139.333L299.333 139.667L298.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M322 139L323 140L322 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M330.667 139.333L331.333 139.667L330.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M332.667 139.333L333.333 139.667L332.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M346 139L346 140L349 140L346 139M355.667 139.333L356.333 139.667L355.667 139.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M260 140L260 141L263 141L260 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M263 140L263 141L266 141L263 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M266 140L266 141L270 141L266 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M294.667 140.333L295.333 140.667L294.667 140.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M324 140L324 141L328 141L324 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M328 140L329 141L328 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M329 140L329 141L332 141L329 140M347 140L347 141L351 141L347 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M351.667 140.333L352.333 140.667L351.667 140.333M406 144L406 152L407 152L406 144M389 152L389 158L390 158L389 152M405 156L405 165L406 165L405 156M388 160L388 163L389 163L388 160M233 161L233 164L234 164L233 161M387.333 163.667L387.667 164.333L387.333 163.667M234.333 164.667L234.667 165.333L234.333 164.667M386.333 165.667L386.667 166.333L386.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M405 165C403.433 182.95 387.847 192.652 371 193L371 194C384.278 193.963 412.186 183.418 405 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M235.333 166.667L235.667 167.333L235.333 166.667M404 166L404 170L405 170L404 166M385 167L384 170L385 167M236 168L236 170L238 170L236 168M238 170L241 173L238 170M383 170L384 171L383 170M403 170L403 173L404 173L403 170M382 171L383 172L382 171M381 172L382 173L381 172M241 173L242 174L241 173M380 173L381 174L380 173M402 173L402 176L403 176L402 173M218.333 174.667L218.667 175.333L218.333 174.667M242.667 174.333L243.333 174.667L242.667 174.333M378.667 174.333L379.333 174.667L378.667 174.333M244 175L245 176L244 175M376.667 175.333L377.333 175.667L376.667 175.333M219 176L220 177L219 176M245 176L245 177L248 177L245 176M374.667 176.333L375.333 176.667L374.667 176.333M401 176L400 180L401 180L401 176M220 177L221 178L220 177M248 177L248 178L251 178L248 177M370 177L370 178L373 178L370 177M221 178L222 179L221 178M251 178L251 179L370 179L334 178L251 178M222 179L223 180L222 179M223 180L224 181L223 180M399 180L400 181L399 180M224 181L225 182L224 181M398 181L399 182L398 181M225 182L226 183L225 182M397 182L398 183L397 182M226 183L228 186L226 183M396 183L397 184L396 183M395 184L396 185L395 184M394 185L395 186L394 185M228 186L229 187L228 186M392.667 186.333L393.333 186.667L392.667 186.333M229 187L230 188L229 187M391 187L392 188L391 187M230 188L231 189L230 188M389.667 188.333L390.333 188.667L389.667 188.333M386 189L386 190L389 190L386 189M231 190L232 191L231 190M379 191L379 192L386 191L379 191M232 191L233 192L232 191M233 192L235 195L233 192M373 192L373 193L378 193L373 192M269 193L269 194L371 194L340 193L269 193M268 194L269 195L268 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M368.667 194.333L369.333 194.667L368.667 194.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M235 195L236 196L235 195M267 195L268 196L267 195M236.333 196.667L236.667 197.333L236.333 196.667M266.333 196.667L266.667 197.333L266.333 196.667M237 198L238 199L237 198M265 198L266 199L265 198M238.333 199.667L238.667 200.333L238.333 199.667M264.333 199.667L264.667 200.333L264.333 199.667M239 201L240 202L239 201M263.333 201.667L263.667 202.333L263.333 201.667M240.333 202.667L240.667 203.333L240.333 202.667M262.333 203.667L262.667 204.333L262.333 203.667M241.333 204.667L241.667 205.333L241.333 204.667M261 205L260 208L261 205M242 206L243 207L242 206M243 208L244 209L243 208M259.333 208.667L259.667 209.333L259.333 208.667M244.333 209.667L244.667 210.333L244.333 209.667M258.333 210.667L258.667 211.333L258.333 210.667M245.333 211.667L245.667 212.333L245.333 211.667M257.333 212.667L257.667 213.333L257.333 212.667M246.333 213.667L246.667 214.333L246.333 213.667M256.333 214.667L256.667 215.333L256.333 214.667M247.333 215.667L247.667 216.333L247.333 215.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M180 253L181 253C181.6 239.072 188.963 225.818 202 219.904C222.671 210.529 247.051 225.675 249 248C254.379 234.807 235.925 219.883 225 216.927C200.879 210.402 180.487 229.425 180 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M255 216L254 219L255 216M209 217L209 218L222 218L209 217M248 217L249 218L248 217M205 218L205 219L208 219L205 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M208 218.468C166.085 226.375 180.422 291.376 222 283.532C265.017 275.417 250.711 210.41 208 218.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M224.667 218.333L225.333 218.667L224.667 218.333M249 218L250 219L249 218M202.667 219.333L203.333 219.667L202.667 219.333M226 219L226 220L229 220L226 219M250 219L250 220L254 220L250 219M200.667 220.333L201.333 220.667L200.667 220.333M229.667 220.333L230.333 220.667L229.667 220.333M198.667 221.333L199.333 221.667L198.667 221.333M231.667 221.333L232.333 221.667L231.667 221.333M197 222L198 223L197 222M233 222L234 223L233 222M195.667 223.333L196.333 223.667L195.667 223.333M234.667 223.333L235.333 223.667L234.667 223.333M194 224L195 225L194 224M208.667 224.333L209.333 224.667L208.667 224.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M243 249L242 249C240.833 258.187 237.913 266.602 229.996 272.2C215.193 282.667 194.497 273.29 190.529 256C187.105 241.077 200.661 224.697 216 225.13C225.969 225.411 233.677 232.228 239 240C239.678 231.748 226.887 225.476 220 224.326C205.372 221.883 189.895 232.794 189.043 248C187.823 269.78 211.464 287.321 230.999 273.362C239.271 267.451 242.232 258.718 243 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M221 224L221 225L224 225L221 224M236 224L237 225L236 224M193 225L194 226L193 225M205.667 225.333L206.333 225.667L205.667 225.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M211 225.468C178.416 231.613 187.457 282.392 220 276.535C253.419 270.521 244.097 219.226 211 225.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M224 225L224 226L227 226L224 225M237 225L238 226L237 225M192 226L193 227L192 226M203.667 226.333L204.333 226.667L203.667 226.333M227.667 226.333L228.333 226.667L227.667 226.333M238 226L239 227L238 226M190 227L190 229L192 227L190 227M201.667 227.333L202.333 227.667L201.667 227.333M229 227L230 228L229 227M239 227L240 228L239 227M199.667 228.333L200.333 228.667L199.667 228.333M230.667 228.333L231.333 228.667L230.667 228.333M240 228L241 229L240 228M189 229L190 230L189 229M198 229L199 230L198 229M232 229L233 230L232 229M241 229L242 230L241 229M188.333 230.667L188.667 231.333L188.333 230.667M197 230L198 231L197 230M233 230L235 232L235 230L233 230M242 230L243 231L242 230M196 231L197 232L196 231M243.333 231.667L243.667 232.333L243.333 231.667M187 232L188 233L187 232M195 232L196 233L195 232M235 232L236 233L235 232M186.333 233.667L186.667 234.333L186.333 233.667M194 233L195 234L194 233M236 233L237 234L236 233M244.333 233.667L244.667 234.333L244.333 233.667M193.333 234.667L193.667 235.333L193.333 234.667M237 234L238 235L237 234M185.333 235.667L185.667 236.333L185.333 235.667M238 235L240 238L238 235M245.333 235.667L245.667 236.333L245.333 235.667M192 236L193 237L192 236M184 237L185 238L184 237M246.333 237.667L246.667 238.333L246.333 237.667M191 238L192 239L191 238M240 238L241 243L242 243L240 238M183 239L183 242L184 242L183 239M190 239L190 242L191 242L190 239M247 240L247 243L248 243L247 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M240.333 241.667L240.667 242.333L240.333 241.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M182 242L182 246L183 246L182 242M189.333 242.667L189.667 243.333L189.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M241 243L241 247L242 247L241 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M248 243L248 246L249 246L248 243M242 244L242 249L243 249L242 244M188 245L188 257L189 257L188 245M181 247L182 259L183 259L181 247M249 248L248 259L249 259L249 248M243 250L243 253L244 253L243 250M242 253L242 259L243 259L242 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M163 256L163 257C181.574 263.332 186.621 299.623 164 304L164 305C187.955 302.398 183.626 259.767 163 256M181 256C184.235 295.285 246.548 295.287 250 256L249 256C243.76 278.64 218.938 293.099 198 279.612C188.247 273.329 186.656 264.988 181 256M325 321L325 320C317.879 319.94 312.198 318.187 307.093 312.957C303.729 309.509 301.032 303.199 295.996 301.931C291.806 300.875 287.916 304.732 284 305.606C275.723 307.454 265.218 305.059 259.329 298.815C243.625 282.167 259.743 257.056 280 257C259.49 248.397 246.379 281.13 255.225 296C261.224 306.086 274.086 308.746 285 306.66C288.382 306.013 292.888 302.116 296.334 303.508C300.645 305.251 302.996 311.65 306.184 314.815C311.466 320.057 317.902 320.98 325 321M154 257L154 258L158 258L154 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M158 257L158 258C170.666 258.115 177.468 271.352 178 283C182.927 270.916 169.138 257.032 158 257M271 257L271 258L281 258L271 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M281 257L281 258C288.145 259.275 294.11 263.916 298.031 270C300.027 273.096 300.857 277.846 304.225 279.817C310.321 283.385 321.378 277.651 329 280.563C348.452 287.997 340.574 311.44 326 319C340.287 322.284 344.758 294.637 338.867 286.093C333.583 278.431 323.536 277.314 315 278.104C312.136 278.369 308.861 280.101 306.055 278.868C301.652 276.934 300.468 270.696 298.034 267.004C294.099 261.036 288.015 257.617 281 257M149 305L149 304C144.444 302.92 137.703 298.556 133.133 301.042C129.327 303.113 128.389 308.771 125.66 311.957C120.048 318.507 108.957 321.231 101 317.427C84.1831 309.39 87.4823 280.929 107 279.39C113.351 278.89 124.048 288.27 128.682 285.863C131.988 284.147 132.043 276.22 133.519 273C137.124 265.129 144.604 260.258 153 259C144.072 255.834 134.316 266.588 131.468 274C130.492 276.54 130.758 283.21 127.968 284.427C125.541 285.486 121.998 282.355 119.999 281.323C115.432 278.965 110.165 277.447 105 278.329C86.0481 281.569 82.7837 310.689 100.001 318.583C108.467 322.464 121.29 319.907 127.2 312.699C129.708 309.64 130.312 303.898 134.133 302.133C137.948 300.371 144.885 304.443 149 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M153 258L153 259L157 259L153 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M157 258.439C148.905 259.71 139.789 262.77 135.327 270.184C133.01 274.035 133.142 284.805 128.721 286.478C125.298 287.773 120.947 283.757 118 282.443C111.089 279.361 103.059 278.812 97.0941 284.225C84.375 295.766 91.5224 319.932 110 318.787C115.915 318.42 122.59 315.799 126.147 310.907C128.737 307.343 129.226 301.321 134.044 299.846C137.781 298.703 142.454 301.571 146 302.572C154.875 305.076 166.518 305.825 173.471 298.532C185.246 286.18 175.659 255.509 157 258.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M189.333 258.667L189.667 259.333L189.333 258.667M255 274L256 274C258.952 267.247 263.307 262.187 270 259C262.545 257.919 256.791 267.912 255 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M270 258.649C254.378 263.363 248.343 288.134 260.329 299.319C266.486 305.066 276.943 306.535 285 304.582C288.974 303.618 292.67 299.9 296.985 301.503C308.263 305.694 309.569 323.498 326 318.347C338.439 314.448 345.04 295.025 335.66 285.214C331.102 280.447 322.404 278.291 316 279.326C312.477 279.896 308.597 282.314 305.044 280.728C300.231 278.579 299.072 271.965 296.211 268.004C290.546 260.163 279.507 255.78 270 258.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M282 258L282 259L285 259L282 258M149 259L149 260L152 260L149 259M241 259L240 264L241 264L241 259M285.667 259.333L286.333 259.667L285.667 259.333M146 260L146 261L149 261L146 260M183.333 260.667L183.667 261.333L183.333 260.667M247.333 260.667L247.667 261.333L247.333 260.667M287.667 260.333L288.333 260.667L287.667 260.333M144.667 261.333L145.333 261.667L144.667 261.333M190.333 261.667L190.667 262.333L190.333 261.667M289.667 261.333L290.333 261.667L289.667 261.333M142.667 262.333L143.333 262.667L142.667 262.333M246 262L246 265L247 265L246 262M291 262L292 263L291 262M141 263L142 264L141 263M154.667 263.333L155.333 263.667L154.667 263.333M184.333 263.667L184.667 264.333L184.333 263.667M191.333 263.667L191.667 264.333L191.333 263.667M292 263L293 264L292 263M138 266L141 264L138 266M149 264L149 265L152 265L149 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M152 264.472C128.14 268.803 136.077 304.988 160 299.606C181.729 294.719 173.739 260.526 152 264.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M158 264L158 265L162 265L158 264M239 264L238 267L239 264M293 264L294 265L293 264M146.667 265.333L147.333 265.667L146.667 265.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M153 265.482C130.293 269.182 136.42 302.339 159 298.786C179.715 295.527 173.469 262.147 153 265.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M162.667 265.333L163.333 265.667L162.667 265.333M185.333 265.667L185.667 266.333L185.333 265.667M192 265L193 266L192 265M245.333 265.667L245.667 266.333L245.333 265.667M271 300L271 299C255.137 290.765 257.778 268.743 276 266C269.08 263.546 261.931 270.859 259.854 277C256.637 286.512 261.6 296.804 271 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M276 265.751C253.25 267.051 256.076 301.242 279 299.957C300.627 298.744 297.52 264.521 276 265.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M277 265L277 266L282 266L277 265M294 265L295 266L294 265M137 266L136 268L138 268L137 266M145 266L146 267L145 266M164.667 266.333L165.333 266.667L164.667 266.333M193.333 266.667L193.667 267.333L193.333 266.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M276 266.751C254.592 268.008 257.468 300.898 279 298.894C299.237 297.011 296.178 265.566 276 266.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M283.667 266.333L284.333 266.667L283.667 266.333M295 266L296 267L295 266M142 269L145 267L142 269M166 267L167 268L166 267M186.333 267.667L186.667 268.333L186.333 267.667M237 267L238 268L237 267M244.333 267.667L244.667 268.333L244.333 267.667M285.667 267.333L286.333 267.667L285.667 267.333M296 267L298 270L296 267M167 268L168 269L167 268M194 268L195 269L194 268M236 268L234 271L236 268M287 268L288 269L287 268M135 269L136 270L135 269M141 269L142 270L141 269M168 269L169 270L168 269M187 269L188 270L187 269M195 269L196 270L195 269M243 269L244 270L243 269M288 269L289 270L288 269M134.333 270.667L134.667 271.333L134.333 270.667M140.333 270.667L140.667 271.333L140.333 270.667M169 270L170 271L169 270M188.333 270.667L188.667 271.333L188.333 270.667M196 270L197 271L196 270M242.333 270.667L242.667 271.333L242.333 270.667M289 270L290 271L289 270M298.333 270.667L298.667 271.333L298.333 270.667M170.333 271.667L170.667 272.333L170.333 271.667M197 271L198 272L197 271M233 271L234 272L233 271M290 271L291 272L290 271M133.333 272.667L133.667 273.333L133.333 272.667M139 272L138 275L139 272M189 272L190 273L189 272M198 272L199 273L198 272M232 272L233 273L232 272M241 272L242 273L241 272M291 272L293 275L291 272M299.333 272.667L299.667 273.333L299.333 272.667M171.333 273.667L171.667 274.333L171.333 273.667M190 273L191 274L190 273M199 273L200 274L199 273M231 273L232 274L231 273M240 273L241 274L240 273M191 274L192 275L191 274M201 274L202 275L201 274M229.667 274.333L230.333 274.667L229.667 274.333M239 274L240 275L239 274M300 274L300 277L301 277L300 274M132 275L132 278L133 278L132 275M137 275L137 279L138 279L137 275M172.333 275.667L172.667 276.333L172.333 275.667M192 275L193 276L192 275M202.667 275.333L203.333 275.667L202.667 275.333M227.667 275.333L228.333 275.667L227.667 275.333M238 275L239 276L238 275M254 275L254 279L255 279L254 275M293 275L293 278L294 278L293 275M193 276L194 277L193 276M204 276L204 277L207 277L204 276M225.667 276.333L226.333 276.667L225.667 276.333M237 276L238 277L237 276M173 277L173 287L174 287L173 277M194.667 277.333L195.333 277.667L194.667 277.333M207 277L207 278L211 278L207 277M220 277L220 278L224 278L220 277M236 277L237 278L236 277M301.333 277.667L301.667 278.333L301.333 277.667M131 278L131 284L132 284L131 278M196 278L197 279L196 278M211 278L211 279L220 279L211 278M234.667 278.333L235.333 278.667L234.667 278.333M294 278L294 288L295 288L294 278M105 279L105 280L111 280L105 279M197 279L198 280L197 279M232.667 279.333L233.333 279.667L232.667 279.333M253 279L253 288L254 288L253 279M302 279L303 280L302 279M312 279L312 280L315 280L312 279M323 279L323 280L326 280L323 279M101 280L101 281L104 281L101 280M113 280L113 281L118 282L118 281L113 280M199 280L200 281L199 280M228 281L228 282L232 281L228 281M303.667 280.333L304.333 280.667L303.667 280.333M310.667 280.333L311.333 280.667L310.667 280.333M327 280L327 281L330 281L327 280M99.6667 281.333L100.333 281.667L99.6667 281.333M200 281L200 282L203 282L200 281M305 281L305 282L309 282L305 281M330.667 281.333L331.333 281.667L330.667 281.333M98 282L99 283L98 282M118.667 282.333L119.333 282.667L118.667 282.333M203 282L203 283L206 283L203 282M226.667 282.333L227.333 282.667L226.667 282.333M332.667 282.333L333.333 282.667L332.667 282.333M94 287L98 283L94 287M95 306L96 306C92.307 292.006 99.8939 284.009 114 284C100.15 278.188 89.9307 293.983 95 306M120.667 283.333L121.333 283.667L120.667 283.333M206 283L206 284L209 284L206 283M222 283L222 284L225 284L222 283M334 283L335 284L334 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M95 295L96 295C97.3606 292.297 98.6804 289.705 101.13 287.804C117.641 274.986 133.729 307.702 110 312C116.263 314.413 122.282 307.803 123.606 302C125.913 291.882 117.956 283.534 108 284.044C105.101 284.193 102.417 284.917 100.044 286.653C97.0472 288.846 95.7099 291.484 95 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M115 284L118 286L115 284M122 284L123 285L122 284M209 284L209 285L222 285L209 284M307 295L308 295C314.135 282.143 331.409 281.897 335 297C337.007 290.811 329.599 285.087 324 284.214C315.671 282.914 309.359 287.064 307 295M335 284L336 285L335 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M104.005 285.703C87.2054 291.481 97.2144 317.496 113.996 311.422C130.865 305.317 120.936 279.88 104.005 285.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M123 285L124 286L123 285M130 285L129 287L131 287L130 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M316.015 285.653C298.961 291.142 309.023 317.93 325.996 312.146C343.868 306.055 333.581 279.998 316.015 285.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M336 285L337 286L336 285M118 286L119 287L118 286M124.667 286.333L125.333 286.667L124.667 286.333M137 286L137 289L138 289L137 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#feffff",
      stroke: "none"
    },
    d: "M316.004 286.858C300.679 293.149 311.009 316.768 325.996 310.852C341.705 304.651 332.012 280.287 316.004 286.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M337.333 286.667L337.667 287.333L337.333 286.667M93 287L92 290L93 287M119 287L120 288L119 287M127.667 287.333L128.333 287.667L127.667 287.333M120 288L122 290L122 288L120 288M172.333 288.667L172.667 289.333L172.333 288.667M178 288L178 292L179 292L178 288M254 288L254 292L255 292L254 288M293 288L293 291L294 291L293 288M338 288L339 289L338 288M339 289L339 292L340 292L339 289M91 290L91 293L92 293L91 290M122.333 290.667L122.667 291.333L122.333 290.667M138 290L140 293L138 290M171.333 290.667L171.667 291.333L171.333 290.667M292.333 291.667L292.667 292.333L292.333 291.667M123.333 292.667L123.667 293.333L123.333 292.667M170 292L171 293L170 292M177.333 292.667L177.667 293.333L177.333 292.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M205 293L205 294L220 293L205 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M255.333 292.667L255.667 293.333L255.333 292.667M340 292L340 302L341 302L340 292M90 293L90 297L91 297L90 293M140 293L141 294L140 293M169.333 293.667L169.667 294.333L169.333 293.667M210 293L210 294L221 294L210 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M221 293L221 294L226 294L221 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M291 293L292 294L291 293M141 294L142 295L141 294M176.333 294.667L176.667 295.333L176.333 294.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M196 296L196 297L204 295L196 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M204.667 294.333L205.333 294.667L204.667 294.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M169 327L164.039 372L164 400L169 400L169 416L170 416C170 379.511 154.922 313.62 201 297.09C208.733 294.316 216.924 295 225 295C210.787 289.036 190.564 297.748 181.669 309.001C177.904 313.763 174.763 325.109 169 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M225 294L225 295L228 295L225 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M228 294L228 295C242.777 298.542 255.829 311.621 260 326L261 326C257.855 310.964 243.534 296.337 228 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M256.333 294.667L256.667 295.333L256.333 294.667M290 294L291 295L290 294M124 295L124 302L125 302L124 295M142 295L143 296L142 295M168 295L169 296L168 295M200.667 295.333L201.333 295.667L200.667 295.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067f8a",
      stroke: "none"
    },
    d: "M265 333C258.015 329.369 257.934 320.029 253.507 314.015C242.525 299.096 225.962 293.244 208 295.174C165.684 299.72 164.387 360.485 168.576 392C169.549 399.323 167.263 414.897 171.858 420.682C175.504 425.272 187.731 423 193 423L240 423C245.926 423 255.366 424.792 260.852 422.397C268.406 419.098 259.898 406.384 269.019 402.742C277.367 399.409 302.172 407.706 306.258 397.941C308.505 392.572 306.469 385.537 306.09 380C305.388 369.754 306 359.269 306 349C306 345.212 304.275 335.408 307.585 332.752C312.312 328.958 313.926 341.718 313.985 344C314.391 359.546 312.612 377.795 315.773 392.996C317.578 401.674 339.547 404.095 343.258 395.853C345.39 391.116 344.992 383.146 345 378C345.024 362.984 348.362 337.28 332.996 328.228C324.145 323.015 316.684 330.376 308.004 328.643C303.179 327.68 299.65 322.26 295.996 319.315C290.445 314.84 284.057 312.952 277 313.005C273.232 313.033 268.505 313.125 266.742 317.133C264.775 321.608 265.905 328.123 265 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M226 295L226 296L229 296L226 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M229.667 295.333L230.333 295.667L229.667 295.333M289 295L290 296L289 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M94 296L94 302L95 302L94 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M143 296L144 297L143 296M165 298L168 296L165 298M175 296L174 299L175 296M198 296L199 297L198 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M230 296L230 297L250 309C245.004 302.824 237.624 298.196 230 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M232.667 296.333L233.333 296.667L232.667 296.333M257 296L258 297L257 296M288 296L289 297L288 296M306 296L306 302L307 302L306 296M144 297L145 298L144 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M177 314L178 314L195 298C187.406 297.347 179.989 308 177 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M195.667 297.333L196.333 297.667L195.667 297.333M234.667 297.333L235.333 297.667L234.667 297.333M258.333 297.667L258.667 298.333L258.333 297.667M287 297L288 298L287 297M145.667 298.333L146.333 298.667L145.667 298.333M163.667 298.333L164.333 298.667L163.667 298.333M194 298L195 299L194 298M236 298L237 299L236 298M285.667 298.333L286.333 298.667L285.667 298.333M133 299L133 300L138 300L133 299M147 299L147 300L150 300L147 299M161.667 299.333L162.333 299.667L161.667 299.333M171 301L174 299L171 301M192 299L193 300L192 299M238 299L239 300L238 299M259 299L262 301L259 299M283.667 299.333L284.333 299.667L283.667 299.333M130 303L133 300L130 303M138.667 300.333L139.333 300.667L138.667 300.333M150 300L150 301L161 301L150 300M190 300L191 301L190 300M240 300L241 301L240 300M272 300L272 301L282 301L272 300M294.667 300.333L295.333 300.667L294.667 300.333M90 301L90 306L91 306L90 301M141.667 301.333L142.333 301.667L141.667 301.333M170 301L171 302L170 301M189 301L190 302L189 301M241 301L242 302L241 301M262 301L263 302L262 301M291 301L291 302L294 302L291 301M296 301L296 302L302 306L296 301M335 301L335 304L336 304L335 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M95.3333 302.667L95.6667 303.333L95.3333 302.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M143 302L143 303L146 303L143 302M168.667 302.333L169.333 302.667L168.667 302.333M187 302L188 303L187 302M243 302L244 303L243 302M263.667 302.333L264.333 302.667L263.667 302.333M288 304L291 302L288 304M339 302L339 305L340 305L339 302M123.333 303.667L123.667 304.333L123.333 303.667M129 303L129 306L130 306L129 303M146 303L146 304L156 305L146 303M164 303L164 304L168 304L164 303M244 303L245 304L244 303M265.667 303.333L266.333 303.667L265.667 303.333M307.333 303.667L307.667 304.333L307.333 303.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M96 304C97.7747 310.266 102.8 312.678 109 313L109 312C102.915 311.373 99.9579 308.331 96 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M158 304L158 305L164 305L158 304M185 304L186 305L185 304M245 304L246 305L245 304M268.667 304.333L269.333 304.667L268.667 304.333M286.667 304.333L287.333 304.667L286.667 304.333M334.333 304.667L334.667 305.333L334.333 304.667M122.333 305.667L122.667 306.333L122.333 305.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M150 305L150 306L163 306L150 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M184 305L185 306L184 305M246 305L247 306L246 305M271 305L271 306L286 306L271 305M308.333 305.667L308.667 306.333L308.333 305.667M91 306L92 310L93 310L91 306M128 306L128 309L129 309L128 306M302.333 306.667L302.667 307.333L302.333 306.667M333 306L332 309L333 306M338 306L339 307L338 306M96 307L97 308L96 307M121 307L118 311L121 307M182 307L183 308L182 307M309 307L310 308L309 307M337.333 307.667L337.667 308.333L337.333 307.667M97 308L98 309L97 308M303 308L304 309L303 308M310 308L311 309L310 308M98 309L98 311L100 311L98 309M127 309L128 310L127 309M181 309L182 310L181 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M250 309C252.7 315.066 258.677 331.021 265 333C266.131 328.251 264.902 322.509 266.742 318.055C268.627 313.492 273.665 312.959 278 313.019C291.767 313.208 296.475 325.729 308 329L308 328C297.162 321.897 291.845 312.103 278 312.005C273.78 311.975 268.575 311.97 266.179 316.133C263.681 320.475 265.16 327.13 264 332L262 332C259.735 323.702 256.81 314.628 250 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M311 309L312 310L311 309M331 309L332 310L331 309M336.333 309.667L336.667 310.333L336.333 309.667M93.3333 310.667L93.6667 311.333L93.3333 310.667M126.333 310.667L126.667 311.333L126.333 310.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M153 310L153 311L168 316C164.455 310.195 159.273 310.004 153 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M180 310L181 311L180 310M252 310L253 311L252 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M275 310C266.519 312.712 264.007 314.755 264 324L265 324C265.031 315.196 268.142 313.513 276 311L275 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M304 310L305 311L304 310M312 310L313 311L312 310M329.667 310.333L330.333 310.667L329.667 310.333M100.667 311.333L101.333 311.667L100.667 311.333M117 311L118 312L117 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M136 320L152 312C146.802 310.575 138.769 315.687 136 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M152 311L152 312L155 312L152 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M155 311L155 312L160 312L155 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M160.667 311.333L161.333 311.667L160.667 311.333M179 311L180 312L179 311M275 311L275 312L279 312L275 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M279 311L279 312L288 313L279 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M305 311L306 312L305 311M313.667 311.333L314.333 311.667L313.667 311.333M328 311L329 312L328 311M335 311L336 312L335 311M94 312L95 313L94 312M102.667 312.333L103.333 312.667L102.667 312.333M115 312L116 313L115 312M125 312L126 313L125 312M149 312L150 313L149 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M123 328L121 338L122 338L123 331L127 332L126 329L154 313C143.657 309.421 132.54 325.738 123 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067f8a",
      stroke: "none"
    },
    d: "M126 329C130.821 344.208 128 363.136 128 379C128 384.363 126.15 394.064 129.028 398.772C132.924 405.145 159.569 404.395 163.972 398.436C166.612 394.864 164.55 387.996 164.17 384C163.346 375.339 164.802 366.649 165.015 358C165.356 344.083 177.742 303.165 149 314.066C145.823 315.27 142.855 316.864 140 318.698C135.118 321.835 130.656 325.549 126 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M161 312L161 313L165 314L165 313L161 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M163 312L164 313L163 312M253 312L254 313L253 312M269.667 312.333L270.333 312.667L269.667 312.333M284 312L285 313L284 312M306 312L307 313L306 312M315 312L315 313L318 313L315 312M325.667 312.333L326.333 312.667L325.667 312.333M334 312L335 313L334 312M95 313L96 314L95 313M104 313L104 314L114 314L104 313M124 313L125 314L124 313M147 313L148 314L147 313M178 313L179 314L178 313M254 313L255 314L254 313M267 313L268 314L267 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M288 313L288 314C298.121 317.005 302.817 329.623 314 327L314 326L288 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M307 313L308 314L307 313M319 313L319 314L324 314L319 313M333 313L334 314L333 313M96 314L97 315L96 314M121 316L124 314L121 316M145 314L146 315L145 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M165 314L167 320L168 320L165 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M177 314L178 315L177 314M266 314L267 315L266 314M290 314L291 315L290 314M308 314L309 315L308 314M332 314L333 315L332 314M97 315L98 316L97 315M143 315L144 316L143 315M166 315L167 316L166 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M176 315L170 324L169 317L168 317L171 327L176 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M255 315L256 316L255 315M265.333 315.667L265.667 316.333L265.333 315.667M292 315L293 316L292 315M309 315L310 316L309 315M331 315L332 316L331 315M98.6667 316.333L99.3333 316.667L98.6667 316.333M119.667 316.333L120.333 316.667L119.667 316.333M141 316L142 317L141 316M167 316L168 317L167 316M176 316L177 317L176 316M256 316L257 317L256 316M293.667 316.333L294.333 316.667L293.667 316.333M310.667 316.333L311.333 316.667L310.667 316.333M330 316L331 317L330 316M100.667 317.333L101.333 317.667L100.667 317.333M116 317L116 318L119 318L116 317M140 317L141 318L140 317M295 317L296 318L295 317M312.667 317.333L313.333 317.667L312.667 317.333M328.667 317.333L329.333 317.667L328.667 317.333M103 318L103 319L106 319L103 318M112 318L112 319L115 319L112 318M138 318L139 319L138 318M175 318L176 319L175 318M257 318L258 319L257 318M296 318L297 319L296 318M314.667 318.333L315.333 318.667L314.667 318.333M326.667 318.333L327.333 318.667L326.667 318.333M137 319L138 320L137 319M168.333 319.667L168.667 320.333L168.333 319.667M297 319L298 320L297 319M317 319L317 320L326 320L317 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M134 320L125 326L125 327L134 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M135 320L136 321L135 320M174 320L175 321L174 320M258.333 320.667L258.667 321.333L258.333 320.667M299 320L300 321L299 320M134 321L135 322L134 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M168 321L168 326L169 326L168 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M300 321L301 322L300 321M133 322L134 323L133 322M173 322L174 323L173 322M301 322L302 323L301 322M131 323L132 324L131 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M100 325L100 326L124 327C116.878 323.207 107.713 323.568 100 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M130 324L131 325L130 324M172.333 324.667L172.667 325.333L172.333 324.667M259 324L260 325L259 324M264 324L262 331L262 332C265.076 330.006 265.383 327.332 264 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M319 324L319 325C339.177 325.002 345.848 340.602 346 359C353.749 340.492 335.587 324 319 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M103 325L103 326L106 326L103 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M106 325L106 326L112 326L106 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M112 325L112 326L115 326L112 325M129 325L130 326L129 325M169.333 325.667L169.667 326.333L169.333 325.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M315 325L315 326L318 326L315 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M318.667 325.333L319.333 325.667L318.667 325.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M309 328L309 329C322.512 327.822 330.242 323.3 340 336C339.015 320.374 317.757 326.712 309 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M329 325L330 326L329 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M90 401L90 400C81.0379 397.402 83.5763 387.304 82.7145 380C80.5776 361.889 81.2942 337.241 99 327C92.9631 326.504 88.0517 334.073 85.8765 339C79.8575 352.634 80.4522 368.519 81.8302 383C82.5194 390.242 80.6466 399.54 90 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M96 328L96 329L101 327L96 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M99 327L99 328L105 327L99 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#067f8a",
      stroke: "none"
    },
    d: "M124 329C89.8018 317.419 79.929 351.227 83.5756 379C84.2782 384.351 83.056 391.982 86.1752 396.697C90.1706 402.736 116.444 402.415 119.218 395.231C120.91 390.85 119 382.776 119 378C119 362.496 117.323 343.308 124 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M113 326L113 327L122 328L113 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M118.667 326.333L119.333 326.667L118.667 326.333M171 326L172 327L171 326M260.333 326.667L260.667 327.333L260.333 326.667M304 326L305 327L304 326M314.667 326.333L315.333 326.667L314.667 326.333M332 326L333 327L332 326M122 327L122 328L127 328L122 327M170 327L171 328L170 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M261 327L264 331L264 327L261 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M312 327L313 328L312 327M333 327L334 328L333 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M97 328L98 329L97 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M308 328L309 329L308 328M335 328L336 329L335 328M94 329L90 334L94 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M95.6667 329.333L96.3333 329.667L95.6667 329.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M261 329L262 330L261 329M336 329L337 330L336 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M94 330L95 331L94 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M337 330L338 331L337 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M93 331L94 332L93 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M123 331L124 332L123 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M124 331L123 335L124 335L125 333L126 337L127 337L126 331L124 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M268 402L268 403L294 403C297.501 403 302.513 403.809 305.347 401.258C310.276 396.821 307.709 386.666 307.17 381C305.642 364.941 307 348.134 307 332L312 334C306.075 324.942 306 342.935 306 346C306 358.465 304.801 371.635 306.424 384C307.089 389.062 308.454 396.782 303.772 400.397C296.863 405.73 276.558 402 268 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M338 331L339 332L338 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M92 332L93 333L92 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M126 332L126 335L127 335L126 332M307 332L307 333L310 333L307 332M339 332L340 333L339 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M91 333L85 347L86 347L91 333M127 333L127 382L128.603 400.347L144 403L144 402C139.61 402 133.771 402.914 130.318 399.566C126.194 395.568 128 386.235 128 381C128 367.485 132.206 345.407 127 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M307 333L307 367L308 367L308 334L312 349L313 349L311 333L307 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M122.333 334.667L122.667 335.333L122.333 334.667M311.333 334.667L311.667 335.333L311.333 334.667M340 334L341 335L340 334M89 335L90 336L89 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M312 335L313 348L314 348L312 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M88 336L89 337L88 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M122 336L122 342L123 342L122 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M341 336L342 337L341 336M126 337L126 342L127 342L126 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M341 337L343 346L344 346L341 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M87 338L88 339L87 338M121 338L121 343L122 343L121 338M342 338L343 339L342 338M312 339L312 342L313 342L312 339M86 340L87 341L86 340z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M120 341L120 349L121 349L120 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M343 341L344 342L343 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M126.333 342.667L126.667 343.333L126.333 342.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M85 343L86 344L85 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M121 343L121 353L122 353L121 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M126 344L126 349L127 349L126 344M344.333 345.667L344.667 346.333L344.333 345.667M84.3333 346.667L84.6667 347.333L84.3333 346.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M344 347L345 384L346 384C346 372.791 348.668 357.399 344 347M84 348L83 362L84 362L84 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M313 348L313 366L314 366L313 348M120 349L120 354L121 354L120 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M126 349L126 352L127 352L126 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M83.3333 350.667L83.6667 351.333L83.3333 350.667M345.333 351.667L345.667 352.333L345.333 351.667M126 352L126 392L127 392C127 380.566 130.411 362.512 126 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M312 352L313 353L312 352M120 354L120 392L121 392C121 381.089 124.211 364.036 120 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M314 355L314 384L315 384L314 355M119 356L119 392L120 392C120 381.613 123.011 365.56 119 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M82 358L82 364L83 364L82 358M346 359L346 375L347 375L346 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M82 364L82 373L83 373L82 364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M313 366C313 372.17 310.228 387.83 315 392L313 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M307 367L307 384L308 384L307 367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M308 371C308 377.997 311.251 396.457 305.566 401.397C300.14 406.112 282.94 402.986 276 403C271.639 403.009 266.643 402.866 265.319 408.019C264.34 411.827 265.698 416.168 266 420L267 420C266.925 416.353 265.313 411.521 266.618 408.059C268.387 403.368 273.935 404.002 278 404C284.751 403.997 301.276 406.994 306.566 402.397C310.957 398.581 309 388.205 309 383C309 379.017 309.552 374.699 308 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M82 373L82 379L83 379L82 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M346 375L346 386L347 386L346 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M83 378C83 385.59 81.1993 398.45 91 400L91 399C81.6163 396.214 85.9173 384.952 83 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M314 384L314 391L315 391L314 384M345 384L345 387L346 387L345 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M344 386C343.996 392.127 344.189 397.863 337 399L337 400C344.476 399.431 346.736 392.52 344 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M345 387C344.996 393.127 345.189 398.863 338 400L338 401C345.877 400.742 347.866 393.83 345 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M83 391L83 394L84 394L83 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M315 391C315.109 395.485 315.562 398.302 320 400L320 399L315 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M120 392L121 393L120 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M126 392L127 393L126 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M314 392L314 395L315 395L314 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M120 393C119.699 396.952 118.882 398.822 115 400L115 401C119.559 400.273 121.831 397.54 120 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M126 393L127 394L126 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M119 394L120 395L119 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M126 394L127 402L128 402L126 394M314 395L315 399L316 399L314 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M84.3333 396.667L84.6667 397.333L84.3333 396.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M119 396L114 399L114 400L119 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M344 396L345 397L344 396M119.333 397.667L119.667 398.333L119.333 397.667M315 397L316 398L315 397M85 398L86 399L85 398M307.333 398.667L307.667 399.333L307.333 398.667M343 398L344 399L343 398M86 399L87 400L86 399M118 399L119 400L118 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M316 399L316 400L320 401L320 400L316 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M317 399L318 400L317 399M342 399L343 400L342 399M90 400L90 401L115 401L90 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M149 402L149 403L163 401L149 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M163.667 400.333L164.333 400.667L163.667 400.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M162 401L162 402L167 401C168.456 407.117 165.345 420.048 171.344 423.821C176.273 426.921 186.363 425 192 425L245 425C251.406 425 262.466 427.409 266 421C259.323 425.511 250.765 424 243 424L195 424C188.816 424 179.841 425.64 174.019 423.397C163.247 419.245 175.72 398.873 162 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M168 400L169 401L168 400M306.333 400.667L306.667 401.333L306.333 400.667M320 400L320 401L338 401L320 400M128 401L128 402L132 403L132 402L128 401M160.667 401.333L161.333 401.667L160.667 401.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M129 402L130 403L129 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M156.667 402.333L157.333 402.667L156.667 402.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M158 402L158 403L161 403L158 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M304.667 402.333L305.333 402.667L304.667 402.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M130 403L130 404L136 404L130 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M136 403L136 404L151 404L136 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M151 403L151 404L157 404L151 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M266 403L264 407L265 407L266 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M267 403L268 404L267 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3dbde",
      stroke: "none"
    },
    d: "M137 404L137 405L150 405L137 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M266 404L267 405L266 404M265 405L266 406L265 405M264 407L264 411L265 411L264 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61a5ab",
      stroke: "none"
    },
    d: "M264 411C263.997 414.765 264.64 419.729 260.852 421.972C256.229 424.71 247.218 423 242 423L195 423C187.502 423 174.931 425.794 171 418L170 418C171.914 426.965 184.881 424 192 424L241 424C246.844 424 256.388 425.824 261.772 423.397C266.054 421.466 265.481 414.53 264 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94c0c3",
      stroke: "none"
    },
    d: "M265 415L265 421L266 421L265 415M169 416L169 421L170 421L169 416M170 421L171 422L170 421M264 421L265 422L264 421M172 423L173 424L172 423M263 423L264 424L263 423z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyjob);
export default __webpack_public_path__ + "static/media/applyjob.4460d9567a4c3aac7f2cfd8a1ea5708b.svg";
export { ForwardRef as ReactComponent };